export default __webpack_public_path__ + "static/media/choco-combo@3x.81a0caed.png";